import { createSvgIcon } from "@mui/material";

export const AlignCenterVIcon = createSvgIcon(
  <svg viewBox="0 0 9 15" fill="none">
    <path
      fill="currentColor"
      d="M4.219 0c.35 0 .633.284.633.634v6.004h2.953a.61.61 0 0 1 .633.633.625.625 0 0 1-.633.632H4.852v6.004a.633.633 0 1 1-1.266 0V7.903H.633A.64.64 0 0 1 0 7.271c0-.37.29-.633.633-.633h2.953V.634c0-.35.283-.634.633-.634"
    />
  </svg>,
  "AlignCenterVIcon",
);
